import { BaseDao } from './BaseDao';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { Agency } from '../../models/agency';
import { Observable } from 'rxjs';

export class AgencyDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.AGENCY, apiHelper);
  }

  public ttdLogin(token: string, username: string, password: string): Observable<Agency> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/ttd/login';
    let headers = this.apiHelper.getDefaultHeader();
    let data = {
      token,
      username,
      password
    };
    return this.apiHelper.apiCall(url, 'POST', null, data, headers);
  }

  public getTradeDeskInvite(token: string): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/ttd?token=' + token;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers);
  }
}
